module.exports = __webpack_public_path__ + "0f5b5e2d2c890cafe1a6668d5d0440c8.woff2";